import { useNavigate } from "react-router-dom";
import { DeleteIcon, EditIcon } from "../../assets/icons/Svgs";
import {
  showDeletedAlert,
  showErrorAlert,
  showQuestionDeleteAlert,
  showUpdateAlert,
} from "../../components/molecules/ShowAlert";

export const EstudianteGrupoCard = ({ estudiante = {}, index, onDelete }) => {
  const navigate = useNavigate();

  const {
    persona = {},
    usuario = {},
    estudiante: datosEstudiante = {},
    registroId
  } = estudiante;

  const {
    idEstudiante,
    credito,
    tipoAdmision,
    notaFinal,
    estado,
  } = datosEstudiante;

  const {
    nombre = "",
    apellido = "",
    celular = "",
    ci = "_",
    sexo = "",
  } = persona;
  const { username = "" } = usuario;

  const tipoAdm = tipoAdmision?.trim() || "N/A";
  const notaFin = notaFinal != null ? notaFinal : "N/A";
  const estadoEstudiante = estado?.trim() || "N/A";

  const obtenerEstadoColor = (estado) => {
    if (!estado || estado === "N/A") return "bg-gray-100 text-gray-800 border-gray-300";
    const estadoLower = estado.toLowerCase();
    switch (estadoLower) {
      case 'aprobado':
        return 'bg-green-100 text-green-800 border-green-300';
      case 'reprobado':
        return 'bg-red-100 text-red-800 border-red-300';
      case 'culminado':
        return 'bg-blue-100 text-blue-800 border-blue-300';
      case 'progreso':
        return 'bg-yellow-100 text-yellow-800 border-yellow-300';
      case 'congelado':
        return 'bg-purple-100 text-purple-800 border-purple-300';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300';
    }
  };

  const handleDelete = async () => {
    showQuestionDeleteAlert({
      title: "¿Retirar estudiante del grupo?",
      text: "Esta acción solo lo eliminará de este grupo",
      callback: async (result) => {
        if (!result.isConfirmed) return;
        try {
          await onDelete(registroId);
          showDeletedAlert({ 
            text: "El estudiante fue retirado del grupo correctamente" 
          });
        } catch (error) {
          console.error("Error al eliminar registro:", error);
          showErrorAlert({
            text: "No se pudo retirar al estudiante del grupo"
          });
        }
      },
    });
  };

  const handleUpdate = () => {
    showUpdateAlert({
      callback: () => navigate(`/estudiantes/actualizar/${idEstudiante}`),
    });
  };

  return (
    <tr className="bg-white hover:bg-gray-100 transition-colors duration-300 [&>td]:p-3 [&>td]:text-gray-700 [&>td]:whitespace-nowrap">
      <td className="font-medium border-r border-slate-200 border-t">{index}</td>
      <td className="border-r border-slate-200 border-t">{nombre}</td>
      <td className="border-r border-slate-200 border-t">{apellido}</td>
      <td className="border-r border-slate-200 border-t">{username}</td>
      <td className="border-r border-slate-200 border-t">{celular}</td>
      <td className="border-r border-slate-200 border-t">{ci}</td>
      <td className="border-r border-slate-200 border-t">{sexo}</td>
      <td
        className={`border-r border-slate-200 border-t ${
          tipoAdm === "Regular"
            ? "bg-blue-100 text-blue-800 font-semibold"
            : ""
        }`}
      >
        {credito ?? "No asignado"}
      </td>
      <td className="border-r border-slate-200 border-t">{tipoAdm}</td>
      <td className="border-r border-slate-200 border-t">{notaFin}</td>
      <td className="border-r border-slate-200 border-t">
        <span className={`px-3 py-1 rounded-full text-xs font-semibold border ${obtenerEstadoColor(estadoEstudiante)}`}>
          {estadoEstudiante}
        </span>
      </td>
      <td className="border-slate-200 border-t">
        <div className="flex justify-start gap-4">
          <button
            onClick={handleUpdate}
            className="bg-green-500 p-1 rounded-md text-white hover:bg-green-600 transition-colors"
            title="Editar estudiante"
          >
            <EditIcon className="w-5 h-5" />
          </button>
          <button
            onClick={handleDelete}
            className="bg-red-500 p-1 rounded-md text-white hover:bg-red-600 transition-colors"
            title="Retirar del grupo"
          >
            <DeleteIcon className="w-5 h-5" />
          </button>
        </div>
      </td>
    </tr>
  );
};